// Diferentes estilos de mapa disponibles
export const mapStyles = {
  
  // Nuevo estilo vectorial usando los tiles oficiales de OpenStreetMap
  // Ventajas: actualizaciones minutely, mejor rendimiento, escalado suave, personalización completa
  // Basado en el esquema Shortbread Vector Tile Schema 1.0
  vector: {
    version: 8,
    // glyphs: '/fonts/{fontstack}/{range}.pbf',
    glyphs: 'https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=7O44jGRmL1XJ214S4rhT',
    sources: {
      'osm-vector': {
        type: 'vector',
        tiles: ['https://vector.openstreetmap.org/shortbread_v1/{z}/{x}/{y}.mvt'],
        attribution: '© OpenStreetMap contributors',
        maxzoom: 14
      }
    },
    layers: [
      // Fondo base oscuro
      {
        id: 'background',
        type: 'background',
        paint: {
          'background-color': '#2a2a2a'
        }
      },
      // Océano oscuro
      {
        id: 'ocean',
        type: 'fill',
        source: 'osm-vector',
        'source-layer': 'ocean',
        paint: {
          'fill-color': '#1a1a1a'
        }
      },
      // Polígonos de agua oscuros
      {
        id: 'water-polygons',
        type: 'fill',
        source: 'osm-vector',
        'source-layer': 'water_polygons',
        paint: {
          'fill-color': '#1a1a1a'
        }
      },
      // Líneas de agua oscuras
      {
        id: 'water-lines',
        type: 'line',
        source: 'osm-vector',
        'source-layer': 'water_lines',
        paint: {
          'line-color': '#1a1a1a',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10, 1,
            16, 3
          ]
        }
      },
      //Uso del suelo en tonos oscuros
      {
        id: 'land',
        type: 'fill',
        source: 'osm-vector',
        'source-layer': 'land',
        paint: {
          'fill-color': [
            'case',
            ['==', ['get', 'kind'], 'forest'], '#353535',
            ['==', ['get', 'kind'], 'park'], '#353535',
            ['==', ['get', 'kind'], 'residential'], '#3a3a3a',
            ['==', ['get', 'kind'], 'commercial'], '#404040',
            ['==', ['get', 'kind'], 'industrial'], '#383838',
            ['==', ['get', 'kind'], 'grass'], '#353535',
            '#2a2a2a'
          ]
        }
      },
      // Autopistas y carreteras principales (zoom lejano)
      {
        id: 'streets-major',
        type: 'line',
        source: 'osm-vector',
        'source-layer': 'streets',
        filter: ['in', ['get', 'kind'], ['literal', ['motorway', 'trunk']]],
        minzoom: 6,
        maxzoom: 10,
        paint: {
          'line-color': [
            'case',
            ['==', ['get', 'kind'], 'motorway'], '#404040',
            '#383838'
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6, 1,
            10, 2
          ]
        }
      },
      // Carreteras principales y secundarias (zoom medio)
      {
        id: 'streets-medium',
        type: 'line',
        source: 'osm-vector',
        'source-layer': 'streets',
        filter: ['in', ['get', 'kind'], ['literal', ['motorway', 'trunk', 'primary', 'secondary']]],
        minzoom: 10,
        maxzoom: 13,
        paint: {
          'line-color': [
            'case',
            ['==', ['get', 'kind'], 'motorway'], '#e0e0e0',
            ['==', ['get', 'kind'], 'trunk'], '#e0e0e0',
            ['==', ['get', 'kind'], 'primary'], '#d0d0d0',
            '#c0c0c0'
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            10, [
              'case',
              ['==', ['get', 'kind'], 'motorway'], 2,
              ['==', ['get', 'kind'], 'trunk'], 1.5,
              1
            ],
            13, [
              'case',
              ['==', ['get', 'kind'], 'motorway'], 4,
              ['==', ['get', 'kind'], 'trunk'], 3,
              ['==', ['get', 'kind'], 'primary'], 2.5,
              2
            ]
          ]
        }
      },
      // Todas las calles (zoom cercano)
      {
        id: 'streets-all',
        type: 'line',
        source: 'osm-vector',
        'source-layer': 'streets',
        minzoom: 13,
        paint: {
          'line-color': [
            'case',
            ['==', ['get', 'kind'], 'motorway'], '#ffffff',
            ['==', ['get', 'kind'], 'trunk'], '#e0e0e0',
            ['==', ['get', 'kind'], 'primary'], '#d0d0d0',
            ['==', ['get', 'kind'], 'secondary'], '#c0c0c0',
            ['==', ['get', 'kind'], 'tertiary'], '#b0b0b0',
            ['==', ['get', 'kind'], 'residential'], '#909090',
            '#707070'
          ],
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13, [
              'case',
              ['==', ['get', 'kind'], 'motorway'], 4,
              ['==', ['get', 'kind'], 'trunk'], 3,
              ['==', ['get', 'kind'], 'primary'], 2.5,
              ['==', ['get', 'kind'], 'secondary'], 2,
              ['==', ['get', 'kind'], 'tertiary'], 1.5,
              1
            ],
            18, [
              'case',
              ['==', ['get', 'kind'], 'motorway'], 12,
              ['==', ['get', 'kind'], 'trunk'], 10,
              ['==', ['get', 'kind'], 'primary'], 8,
              ['==', ['get', 'kind'], 'secondary'], 6,
              ['==', ['get', 'kind'], 'tertiary'], 4,
              ['==', ['get', 'kind'], 'residential'], 3,
              2
            ]
          ]
        }
      },
      // Etiquetas de calles principales en blanco (solo zoom cercano)
      {
        id: 'street-labels',
        type: 'symbol',
        source: 'osm-vector',
        'source-layer': 'street_labels',
        minzoom: 12,
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['noto_sans_regular'],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12, 9,
            16, 12
          ],
          'symbol-placement': 'line',
          'text-rotation-alignment': 'map'
        },
        paint: {
          'text-color': '#ffffff',
          'text-halo-color': '#000000',
          'text-halo-width': 1
        }
      },
      // Edificios en gris oscuro
      {
        id: 'buildings',
        type: 'fill',
        source: 'osm-vector',
        'source-layer': 'buildings',
        paint: {
          'fill-color': '#555555',
          'fill-opacity': 0.8,
          'fill-outline-color': '#666666'
        }
      },
      //Etiquetas de lugares en blanco
      {
        id: 'place-labels',
        type: 'symbol',
        source: 'osm-vector',
        'source-layer': 'place_labels',
        filter: ['>=', ['get', 'population'], 1000],
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['noto_sans_regular'],
          'text-size': [
            'interpolate',
            ['linear'],
            ['get', 'population'],
            1000, 10,
            100000, 14,
            1000000, 18
          ]
        },
        paint: {
          'text-color': '#ffffff',
          'text-halo-color': '#000000',
          'text-halo-width': 1
        }
      }
    ]
  }
}
//     layers: [
//       // Fondo base oscuro
//       {
//         id: 'background',
//         type: 'background',
//         paint: {
//           'background-color': '#2a2a2a'
//         }
//       },
//       // Océano oscuro
//       {
//         id: 'ocean',
//         type: 'fill',
//         source: 'osm-vector',
//         'source-layer': 'ocean',
//         paint: {
//           'fill-color': '#1a1a1a'
//         }
//       },
//       // Polígonos de agua oscuros
//       {
//         id: 'water-polygons',
//         type: 'fill',
//         source: 'osm-vector',
//         'source-layer': 'water_polygons',
//         paint: {
//           'fill-color': '#1a1a1a'
//         }
//       },
//       // Líneas de agua oscuras
//       {
//         id: 'water-lines',
//         type: 'line',
//         source: 'osm-vector',
//         'source-layer': 'water_lines',
//         paint: {
//           'line-color': '#1a1a1a',
//           'line-width': [
//             'interpolate',
//             ['linear'],
//             ['zoom'],
//             10, 1,
//             16, 3
//           ]
//         }
//       },
//       // Uso del suelo en tonos oscuros
//       {
//         id: 'land',
//         type: 'fill',
//         source: 'osm-vector',
//         'source-layer': 'land',
//         paint: {
//           'fill-color': [
//             'case',
//             ['==', ['get', 'kind'], 'forest'], '#353535',
//             ['==', ['get', 'kind'], 'park'], '#353535',
//             ['==', ['get', 'kind'], 'residential'], '#3a3a3a',
//             ['==', ['get', 'kind'], 'commercial'], '#404040',
//             ['==', ['get', 'kind'], 'industrial'], '#383838',
//             ['==', ['get', 'kind'], 'grass'], '#353535',
//             '#2a2a2a'
//           ]
//         }
//       },
//       // Autopistas y carreteras principales (zoom lejano)
//       {
//         id: 'streets-major',
//         type: 'line',
//         source: 'osm-vector',
//         'source-layer': 'streets',
//         filter: ['in', ['get', 'kind'], ['literal', ['motorway', 'trunk']]],
//         minzoom: 6,
//         maxzoom: 10,
//         paint: {
//           'line-color': [
//             'case',
//             ['==', ['get', 'kind'], 'motorway'], '#404040',
//             '#383838'
//           ],
//           'line-width': [
//             'interpolate',
//             ['linear'],
//             ['zoom'],
//             6, 1,
//             10, 2
//           ]
//         }
//       },
//       // Carreteras principales y secundarias (zoom medio)
//       {
//         id: 'streets-medium',
//         type: 'line',
//         source: 'osm-vector',
//         'source-layer': 'streets',
//         filter: ['in', ['get', 'kind'], ['literal', ['motorway', 'trunk', 'primary', 'secondary']]],
//         minzoom: 10,
//         maxzoom: 13,
//         paint: {
//           'line-color': [
//             'case',
//             ['==', ['get', 'kind'], 'motorway'], '#e0e0e0',
//             ['==', ['get', 'kind'], 'trunk'], '#e0e0e0',
//             ['==', ['get', 'kind'], 'primary'], '#d0d0d0',
//             '#c0c0c0'
//           ],
//           'line-width': [
//             'interpolate',
//             ['linear'],
//             ['zoom'],
//             10, [
//               'case',
//               ['==', ['get', 'kind'], 'motorway'], 2,
//               ['==', ['get', 'kind'], 'trunk'], 1.5,
//               1
//             ],
//             13, [
//               'case',
//               ['==', ['get', 'kind'], 'motorway'], 4,
//               ['==', ['get', 'kind'], 'trunk'], 3,
//               ['==', ['get', 'kind'], 'primary'], 2.5,
//               2
//             ]
//           ]
//         }
//       },
//       // Todas las calles (zoom cercano)
//       {
//         id: 'streets-all',
//         type: 'line',
//         source: 'osm-vector',
//         'source-layer': 'streets',
//         minzoom: 13,
//         paint: {
//           'line-color': [
//             'case',
//             ['==', ['get', 'kind'], 'motorway'], '#ffffff',
//             ['==', ['get', 'kind'], 'trunk'], '#e0e0e0',
//             ['==', ['get', 'kind'], 'primary'], '#d0d0d0',
//             ['==', ['get', 'kind'], 'secondary'], '#c0c0c0',
//             ['==', ['get', 'kind'], 'tertiary'], '#b0b0b0',
//             ['==', ['get', 'kind'], 'residential'], '#909090',
//             '#707070'
//           ],
//           'line-width': [
//             'interpolate',
//             ['linear'],
//             ['zoom'],
//             13, [
//               'case',
//               ['==', ['get', 'kind'], 'motorway'], 4,
//               ['==', ['get', 'kind'], 'trunk'], 3,
//               ['==', ['get', 'kind'], 'primary'], 2.5,
//               ['==', ['get', 'kind'], 'secondary'], 2,
//               ['==', ['get', 'kind'], 'tertiary'], 1.5,
//               1
//             ],
//             18, [
//               'case',
//               ['==', ['get', 'kind'], 'motorway'], 12,
//               ['==', ['get', 'kind'], 'trunk'], 10,
//               ['==', ['get', 'kind'], 'primary'], 8,
//               ['==', ['get', 'kind'], 'secondary'], 6,
//               ['==', ['get', 'kind'], 'tertiary'], 4,
//               ['==', ['get', 'kind'], 'residential'], 3,
//               2
//             ]
//           ]
//         }
//       },
//       // Etiquetas de calles principales en blanco (solo zoom cercano)
//       {
//         id: 'street-labels',
//         type: 'symbol',
//         source: 'osm-vector',
//         'source-layer': 'street_labels',
//         filter: ['in', ['get', 'kind'], ['literal', ['motorway', 'trunk', 'primary', 'secondary']]],
//         minzoom: 12,
//         layout: {
//           'text-field': ['get', 'name'],
//           'text-font': ['noto_sans_regular'],
//           'text-size': [
//             'interpolate',
//             ['linear'],
//             ['zoom'],
//             12, 9,
//             16, 12
//           ],
//           'symbol-placement': 'line',
//           'text-rotation-alignment': 'map'
//         },
//         paint: {
//           'text-color': '#ffffff',
//           'text-halo-color': '#000000',
//           'text-halo-width': 1
//         }
//       },
//       // Edificios en gris oscuro
//       {
//         id: 'buildings',
//         type: 'fill',
//         source: 'osm-vector',
//         'source-layer': 'buildings',
//         paint: {
//           'fill-color': '#555555',
//           'fill-opacity': 0.8,
//           'fill-outline-color': '#666666'
//         }
//       },
//       // Etiquetas de lugares en blanco
//       {
//         id: 'place-labels',
//         type: 'symbol',
//         source: 'osm-vector',
//         'source-layer': 'place_labels',
//         filter: ['>=', ['get', 'population'], 1000],
//         layout: {
//           'text-field': ['get', 'name'],
//           'text-font': ['noto_sans_regular'],
//           'text-size': [
//             'interpolate',
//             ['linear'],
//             ['get', 'population'],
//             1000, 10,
//             100000, 14,
//             1000000, 18
//           ]
//         },
//         paint: {
//           'text-color': '#ffffff',
//           'text-halo-color': '#000000',
//           'text-halo-width': 1
//         }
//       }
//     ]
//   }
// }

// Estilo por defecto (puedes cambiar aquí el estilo que quieras usar)
export const mapStyleObj = mapStyles.vector // Usando tiles vectoriales oficiales

  // Estilos CSS adicionales para el mapa oscuro
export const mapCSSStyles = `
.dark-popup .maplibregl-popup-content {
  background-color: #2a2a2a !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0,0,0,0.6) !important;
  border: 1px solid #404040 !important;
}

.dark-popup .maplibregl-popup-close-button {
  color: #cccccc !important;
  font-size: 20px !important;
  font-weight: bold !important;
  right: 8px !important;
  top: 8px !important;
}

.dark-popup .maplibregl-popup-close-button:hover {
  color: #ffffff !important;
  background-color: rgba(255,255,255,0.1) !important;
}

.dark-popup .maplibregl-popup-tip {
  border-top-color: #2a2a2a !important;
}

.maplibregl-ctrl-group {
  background-color: #2a2a2a !important;
  border: 1px solid #404040 !important;
}

.maplibregl-ctrl-zoom-in,
.maplibregl-ctrl-zoom-out {
  background-color: #2a2a2a !important;
  color: #cccccc !important;
  border: none !important;
}

.maplibregl-ctrl-zoom-in:hover,
.maplibregl-ctrl-zoom-out:hover {
  background-color: #404040 !important;
  color: #ffffff !important;
}
`